<div
  class="bg-orange-dark-2 text-orange-dark-11 ring-orange-dark-4 inline-flex items-center gap-0.5 whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-semibold ring-1 ring-inset lg:text-[8.5px] xl:text-[10px]"
>
  <span class="block lg:hidden xl:block">Complete your profile</span>
  <span class="hidden lg:block xl:hidden">Complete profile</span>
  <div class="bg-orange-dark-11 ml-1 h-1 w-1 animate-pulse rounded-full"></div>
</div>
